export default __webpack_public_path__ + "static/students_rating-256f09c618f7fc2483e3acb3913cbd6c.png";